export const listingBookingSettings = {
  section01: {
    title: "Prenotazioni dirette per questo annuncio",
  },
  motor: {
    activeTitle: "Motore di prenotazione attivo",
    inactiveTitle: "Motore di prenotazione inattivo",
    activeDesc: "Gli ospiti possono prenotare questo annuncio direttamente dal suo link.",
    inactiveDesc: "Le prenotazioni dirette sono disattivate per questo annuncio.",
    statusOn: "Attivo",
    statusOff: "Inattivo",
  },
  payment: {
    title: "Quando paga l'ospite?",
    onArrival: {
      name: "Paga all'arrivo",
      hint: "Prenota gratis, paga quando arrivi.",
    },
    online: {
      name: "Paga online",
      hint: "Paga al momento della conferma della prenotazione.",
    },
  },
  common: {
    saving: "Salvataggio…",
    onlyOnlineBadge: "Solo pagamento online",
  },
  hold: {
    title: "Tempo di blocco",
    desc: "Il calendario viene bloccato mentre l'ospite completa il pagamento.<br>Se non paga entro il tempo impostato, <strong>la disponibilità viene rilasciata automaticamente</strong>.",
  },
  units: {
    min: "min",
    hour: "ora",
    hours: "ore",
  },
  partial: {
    title: "Pagamento parziale",
    cardTitle: "Consenti di pagare solo una parte alla prenotazione",
    descOn: "<strong>Attivato.</strong> L'ospite può pagare <strong>{percent}%</strong> ora e il resto prima dell'arrivo (oppure pagare l'intero importo).",
    descOff: "<strong>Disattivato.</strong> L'ospite paga l'<strong>intero importo</strong> alla prenotazione.",
    blockTitle: "Il resto viene pagato presso la struttura",
    blockOn: "<strong>Attivato.</strong> L'ospite paga <strong>solo {percent}%</strong> online; il resto viene pagato <strong>all'arrivo</strong> (non può pagare l'intero importo online).",
    blockOff: "<strong>Disattivato.</strong> L'ospite può scegliere se pagare {percent}% o l'intero importo online.",
  },
  reminder: {
    title: "Promemoria saldo",
    cardTitle: "Invia un promemoria per pagare il saldo residuo",
    daysBefore: "{count} giorno prima | {count} giorni prima",
    descOn: "<strong>Attivato.</strong> <strong>{daysBefore}</strong> dell'arrivo (intorno alle 09:00, ora della struttura) all'ospite viene inviato un link per pagare il saldo residuo tramite <strong>WhatsApp ed email</strong>.",
    descOff: "<strong>Disattivato.</strong> L'ospite non riceve alcun promemoria per pagare il saldo online prima dell'arrivo.",
    daysLabel: "Giorni prima dell'arrivo",
    hint: "Inviato una sola volta e solo agli ospiti con un saldo residuo. Se il resto viene pagato presso la struttura, non viene inviato.",
  },
  approve: {
    title: "Approva le prenotazioni",
    cardTitle: "Approva ogni prenotazione prima di confermarla",
    descOn: "<strong>Attivato.</strong> Ogni prenotazione resta <strong>in attesa della tua approvazione</strong>: ricevi una notifica e decidi se accettarla o rifiutarla. Non viene confermata finché non la approvi.",
    descOff: "<strong>Disattivato.</strong> Le prenotazioni vengono <strong>confermate automaticamente</strong> una volta completato il pagamento. Attivalo se preferisci esaminare e approvare personalmente ogni richiesta.",
  },
  toasts: {
    statusUpdatedAll: "Stato aggiornato su tutte le unità.",
    statusUpdated: "Stato aggiornato.",
    statusError: "Impossibile aggiornare.",
    paymentUpdated: "Metodo di pagamento aggiornato.",
    paymentError: "Impossibile salvare il metodo di pagamento.",
    partialUpdated: "Pagamento parziale aggiornato.",
    partialError: "Impossibile salvare il pagamento parziale.",
    reminderUpdated: "Promemoria aggiornato.",
    reminderError: "Impossibile salvare il promemoria.",
    saved: "Salvato.",
    saveError: "Impossibile salvare.",
    linkCopied: "Link copiato.",
    copyError: "Impossibile copiare.",
  },
  share: {
    whatsappText: "Ciao 👋 Ecco il link per prenotare: {link}",
  },
};
